import styled from 'styled-components';

export const FieldWrap = styled.div`
  margin-bottom: 1rem;
`;

export default FieldWrap;
